<template>
    <div>
        <el-table :data="tabledata">
            <el-table-column label="付款时间" prop="typeText">
                <template slot-scope="{ row }">
                    <span>{{ row.payTime || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="付款金额" prop="content">
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.amount || 0) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="付款人" prop="orderId">
                <template slot-scope="{ row }">
                    <span>{{ row.payUserName }} - {{ row.payUserPhone }}</span>
                </template>
            </el-table-column>
            <el-table-column label="记录时间" prop="operatorUserPhone">
                <template slot-scope="{ row }">
                    <span>{{ row.createTime || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="更新时间" prop="operatorUserPhone">
                <template slot-scope="{ row }">
                    <span>{{ row.updateTime || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="付款备注" prop="operatorUserPhone">
                <template slot-scope="{ row }">
                    <span>{{ row.remark || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="付款回单" prop="operatorUserPhone">
                <template slot-scope="{ row }">
                    <div class="a-flex-rfsfs a-flex-wrap">
                        <el-image
                            v-for="(item, index) in row.images"
                            :preview-src-list='row.images'
                            :key="index"
                            style="width: 60px; height: 60px; margin: 0 8px 8px 0; border-radius: 4px"
                            :src="item"></el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="pid" label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="delElectricBill(scope.row)">删除</el-button>
                    <el-button type="text" @click="editElectricBill(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <electric-bill-pay ref="payBill" @change="handlePaySuccess"></electric-bill-pay>
    </div>
</template>

<script>
    import util from '../../../../src/utils/util'
    import ElectricBillPay from '../child/electric-bill-pay.vue'
    export default {
        components: {
            ElectricBillPay
        },
        data() {
            return {
                util: util,
            }
        },
        props:{
            tabledata: {
                default: ()=>{
                    return []
                }
            },
            details: {
                default: ''
            }
        },
        methods:{
            editElectricBill (data) {
                this.$refs['payBill'].billInfo = this.details
                this.$refs['payBill'].editType = 'edit'
                this.$refs['payBill'].id = data.id
                this.$refs['payBill'].form = {
                    ...data,
                    amount: data.amount ? (data.amount/100).toFixed(2) : 0
                }
                this.$refs['payBill'].dialogVisible = true
                this.$nextTick(()=>{
                    this.$refs['payBill'].handleInitUpload()
                })
            },
            handlePaySuccess () {
                this.$emit('change');
            },
            delElectricBill (datas) {
                this.$confirm('是否确认删除？','温馨提示')
                .then(_=>{
                    this.$Axios._get({
                        url: this.$Config.apiUrl.deletePayRecord,
                        params: { 
                            id: datas.id
                        }
                    }).then(res => {
                        this.$message.success('操作成功')
                        this.$emit('change');
                    })
                })
                .catch(_=>{})
            }
        }
    }
</script>